import { useQuery } from '@apollo/client';

import { GetLapYearsQuery } from '@modules/lap/graphql';

import type { QueryHookOptions } from '@apollo/client';
import type { GetLapYearsQueryType, GetLapYearsQueryVariables } from '@modules/types/graphql';

const useLapYears = (
    options?: QueryHookOptions<GetLapYearsQueryType, GetLapYearsQueryVariables>,
) => {
    const queryResult = useQuery<GetLapYearsQueryType, GetLapYearsQueryVariables>(
        GetLapYearsQuery,
        options,
    );

    const lapYears: number[] = queryResult.data?.getLapYears ?? [];
    const count: number = lapYears?.length;

    const result = {
        lapYears,
        count,
        ...queryResult,
    };

    return result;
};

export { useLapYears };
